export default {
	title: "Opções de Atendimento",
	subtitle: "Configurar queixas e recursos para este tipo de atendimento",
	label: "Nome",
	categories: {
		COMPLAINT: "Queixa",
		RESOURCE: "Recurso",
	},
	fieldTypes: {
		CHECKBOX: "Marcar",
		CHECKBOX_WITH_TEXT: "Marcar com texto",
		QUANTITY: "Quantidade",
	},
	form: {
		label: {
			label: "Nome da Opção",
			placeholder: "Ex: Problema respiratório, Velas",
			hint: "Nome que aparecerá na ficha",
		},
		category: {
			label: "Categoria",
			hint: "Queixa: o que será tratado. Recurso: o que será usado.",
		},
		fieldType: {
			label: "Tipo de Campo",
			hint: "Como o atendente preencherá esta opção na ficha",
		},
	},
	create: "Adicionar Opção",
	edit: "Editar Opção",
	delete: "Excluir Opção",
	deleteConfirmation: "Deseja realmente excluir a opção \"{label}\"?",
	messages: {
		created: "Opção \"{label}\" criada com sucesso",
		updated: "Opção \"{label}\" atualizada com sucesso",
		deleted: "Opção \"{label}\" excluída com sucesso",
		loadError: "Erro ao carregar opções",
		createError: "Erro ao criar opção",
		updateError: "Erro ao atualizar opção",
		deleteError: "Erro ao excluir opção",
	},
	empty: {
		title: "Nenhuma opção configurada",
		text: "Adicione queixas e recursos que poderão ser marcados ao emitir fichas deste tipo de atendimento",
	},
	tabs: {
		complaints: "Queixas",
		resources: "Recursos",
	},
	ticket: {
		sectionTitle: "Opções do Atendimento",
		complaints: "Queixas",
		resources: "Recursos",
		customTextPlaceholder: "Descreva...",
		quantityLabel: "Qtd",
		topComplaint: "Queixa principal",
	},
	validation: {
		labelRequired: "Nome é obrigatório",
		categoryRequired: "Categoria é obrigatória",
	},
};
